import { create } from 'zustand';

type RecaptchaState = {
  recaptchaReady: boolean;
  setRecaptchaReady: (ready: boolean) => void;
};

/**
 * This store is only to be used to store BASIC boolean logic for external services.
 * If further logic is needed, create a separate store for that service.
 */
export const useExternalServiceStore = create<RecaptchaState>((set) => ({
  recaptchaReady: false, // initial state
  setRecaptchaReady: (ready) => set({ recaptchaReady: ready }),
}));
